import type { ShareContentType, ShareProgress } from '../share-criteria-types.ts';

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null;

const isFiniteNonNegativeNumber = (value: unknown): value is number =>
	typeof value === 'number' && Number.isFinite(value) && value >= 0;

type ShareProgressForType<T extends ShareContentType> = Extract<ShareProgress, { type: T }>;

export const isShareProgressForType = <T extends ShareContentType>(
	type: T,
	value: unknown,
): value is ShareProgressForType<T> => {
	if (!isRecord(value) || value.type !== type) {
		return false;
	}

	switch (type) {
		case 'live-doc':
			return isFiniteNonNegativeNumber(value.wordDelta);
		case 'whiteboard':
			return isFiniteNonNegativeNumber(value.elements);
		case 'database':
			return (
				isFiniteNonNegativeNumber(value.rows) &&
				isFiniteNonNegativeNumber(value.columns) &&
				isFiniteNonNegativeNumber(value.filledCells)
			);
		case 'slides':
			return false;
	}
};
